import { TableCell } from '@mui/material';
import clsx from 'clsx';
import { useTableStyles } from 'components/Table/styles';
import React from 'react';

import { CellProps } from './types';

const Cell: React.FunctionComponent<CellProps> = (props) => {
  const classes = useTableStyles();
  const { bodyClassName, className, name, render, value, wrap, isExpanded, row, rowRef, minWidth } =
    props;

  return (
    <TableCell
      className={clsx(bodyClassName, className, {
        [classes.cellWithSubRow]: isExpanded,
        [classes.minWidthCell]: minWidth,
      })}
      style={{ minWidth: minWidth && typeof minWidth === 'number' ? minWidth : '' }}
      key={`row_${row.id}_${name}_tableCell`}
    >
      {wrap(render(value, row, rowRef), value, row)}
    </TableCell>
  );
};

export default React.memo(Cell);
